import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "input input_s_m",
  style: {"margin-right":"10px"}
}
const _hoisted_2 = ["value"]

import store from '@/store'
import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'RegionSelect',
  setup(__props) {

const value = computed({
  get: () => store.state.regionId,
  set: (value: number) => store.setCurrentRegion(value)
})

const regions = computed(() => store.state.regions)


return (_ctx: any,_cache: any) => {
  return (regions.value.length !== 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("select", {
          class: "input__field",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("option", { value: undefined }, "Все регионы", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regions.value, (region) => {
            return (_openBlock(), _createElementBlock("option", {
              key: region.id,
              value: region.id
            }, _toDisplayString(region.name), 9, _hoisted_2))
          }), 128))
        ], 512), [
          [_vModelSelect, value.value]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})